/**
 * @fileOverview 这个主要用于处理路径相关的，不依赖于任何框架
 * @author kirkzheng
 */

/**
 * 网站目录
 */
export const dirname = 'ams';

/**
 * @description 模拟 node path模块，用于网站路径处理
 * @namespace tsaPath
 * @property {string} _dirname - 系统部署路径
 * @property {func} genFoldName - 把foldName统一处理为“/folderName”，“/”在前头（主要为网站根目录在前）
 * @property {func} join - 合并路径，join('apath', 'bpath', 'cpath')
 */
export const tsaPath = {
  _dirname: dirname,

  /**
   * @descrption 生成目录名
   * @param {*} folderName
   * @return {String}
   */
  genFoldName(folderName = '') {
    let result = '';
    let name = folderName || '';

    if (name) {
      name = name.replace(/\\/gi, '/');

      if (name.substr(0, 1) != '/') {
        result = '/';
      }

      result += name;

      if (name.substr(-1, 1) == '/') {
        result = result.slice(0, -1);
      }
    }

    return result;
  },

  join() {
    const path = tsaPath || {};
    const _dirname = dirname || '';
    const params = [].slice.call(arguments);
    let resultPath = '';
    let i = 0;
    let len = 0;

    if (_dirname) {
      resultPath += path.genFoldName(_dirname);

      for (len = params.length; i < len; i++) {
        if (params[i]) {
          resultPath += path.genFoldName(params[i]);

          if (i == len - 1 && params[i].substr(-1, 1) == '/') {
            resultPath += '/';
          }
        }
      }
    }

    return resultPath;
  },
};

export default tsaPath;
